module.exports = __webpack_public_path__ + "static/media/git.3480db5e.png";